import styled from 'styled-components';


//Header

export const Cabecalho = styled.header`
    display: block;
`;

export const Propaganda = styled.div`
    background-color: #D2D2D2;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0px;
    color: #FFFFFF;
    // font-size: 14px;
    font-size: clamp(10px, 3vw, 14px);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    
`;

export const NavBAr = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    padding: 10px 5%;
    // background-color: #F5F5F5;
`;

export const ImgShop = styled.div`
    display: flex;
    width: 535px;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    background: #D2D2D2;
`;


export const Navegacao = styled.div`
    display: flex;
    align-items: center;
    // justify-content: space-around;
    justify-content: space-between;
    gap:20px;
    // width: 50%;

    // @media (max-width: 768px) {
    //  width: 80%;
    // }
`;

// export const Logo = styled.h3`
//     color: #000;
//     font-family: Montserrat;
//     font-size: 24px;
//     font-style: normal;
//     font-weight: 700;

//     @media (max-width: 425px) {
//      display: flex;
//     align-items: center;
//     justify-content: center;
//      margin-left:50px;
//     }
// `;

export const ContaiterLogo = styled.div`
    @media (max-width: 425px) {
     display: flex;
    align-items: center;
    justify-content: center;
    }
`;

export const Links = styled.div`
    display: flex;
`;

export const NavLinks = styled.p`
    margin: 10px;
    color: black;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    cursor: pointer;

    @media (max-width: 950px) {
    display: none;
    }

`;

export const Pesquisa = styled.div`
    // padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

`;

export const ContainerPesquisa = styled.div`
    padding: 23px 0px;

    @media (max-width: 425px) {
    // padding: 0;
    padding: 23px 0px;
    }

    @media (max-width: 768px) {
    // padding: 0;
    padding: 23px 0px;
    }
`;

export const BarraPesquisa = styled.div`
    border-radius: 15px;
    border: none;
    background: #F5F5F5;
    display: inline-flex;
    padding: 7px 18px;
    align-items: flex-start;
    gap: 10px;

    @media (max-width: 425px) {
    display: none;
    }

    @media (max-width: 768px) {
    
    }
`;

export const ContainerCompra = styled.div`
    display: flex;
    align-items: center;
    margin-left: 30px;
    padding: 3px;

    @media (max-width: 425px) {
        margin-left: 55px;
    }
`;

export const Usuario = styled.div`
    margin: 8px;
    cursor: pointer;

    @media (max-width: 425px) {
    display: none;
    }
`;

export const Favorito = styled.div`
    margin: 8px;
    cursor: pointer;
`;
export const Sacola = styled.div`
    margin: 8px;
    cursor: pointer;
`;

export const MenuMobile = styled.div`
    display: none;
    cursor: pointer;
`;

export const Input = styled.input`
    border: none;
    background: transparent;
    forcedColorAdjust: none;
    outline: none;
    width: 100%;

    // @media (max-width: 425px) {
    //  width: 100%;
    // }

     @media (width: 768px) {
     width: 140px;
    }
`;

export const CarrinhoCompras = styled.div`
    // width: 28%;
    height: 100%;
    position: fixed;
    top: 0;
    background: #FFF;
    box-shadow: -10px 0 10px -5px rgba(0, 0, 0, 0.07);
    transition: right 0.8s ease;
    transform: translateX(${props => (props.visivel ? '0' : '1%')});
    transform: translateX(${props => (props.visivel ? '0' : '-1%')});
    right: ${props => (props.visivel ? '0' : '-100%')};
    z-index:11;

    // @media (max-width: 425px) {
    //  width: 100%;
    // }

    // @media (min-width: 768px) and (max-width: 1023px){
    //  width: 50%;
    // }

    // @media (min-width: 1023px) and (max-width: 1439px){
    //  width: 40%;
    // }
`;

export const CarrinhoHeader = styled.header`
    display: flex;
    border-bottom: 1px solid #000;
    // justify-content: space-around;
    justify-content: space-between;
    align-items: center;
    padding: 10px 35px;

    @media (max-width: 425px) {
    padding: 5px 15px;
    // gap: 40px;
    }

    // @media (min-width: 2560px) {
    // justify-content: space-between;
    // }
`;

export const ContainerCarrinhoP = styled.div`
`;

export const ContainerP = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;

    @media (max-width: 425px) {
    font-size: 20px;
    }
`;

export const ContainerSacolinha = styled.p`
    cursor: pointer;
    display: flex;
    alignItems: center;
    justifyContent: center;
    position: relative;
`;

export const CarrinhoMain = styled.main`
    width: 100%;
    height: 60%;
    padding: 5px;
    overflow-y: scroll;
    @media (min-width: 2560px) {
     height: 80%;
    }
`;

export const CarrinhoRodape = styled.footer`
    border-top: 1px solid #000;
`;

export const CardP = styled.div`
    padding: 5px;
    display: flex;
    margin: 20px;

    // @media (max-width: 425px) {
    // margin: 5px;
    // }
`;

export const ImgCardP = styled.div`
    width: 30px;
    background-color: #D2D2D2;
    border-radius: 10px;
`;

export const ContainerCardp = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 15px;
    justify-content: flex-end;

    @media (min-width: 2560px) {
        width: 100%;
    }
`;

export const ContainerProduto = styled.div`
    padding-right: 50px;

    @media (max-width: 425px) {
    padding-right: 20px;
    }
`;

export const DadosProduto = styled.div`
`;

export const NomeProduto = styled.p`
    margin: 0;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 5px;
    white-space: nowrap; 
`;

export const ContainerRemover = styled.div`
    margin-left: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const ContainerValoresP = styled.div`
    display: flex;
    align-items: center;
    margin: 0;
`;

export const UnidadeP = styled.p`
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 5px;
`;

export const VezesP = styled.p`
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 5px;
`;

export const ValorP = styled.p`
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 5px;
    color: #848484;
`;

export const CarrinhoValor = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 1px 26px;
    align-items: center;

    @media (max-width: 425px) {
    padding: 1px 15px;
    }
`;

export const ContainerSubtotal = styled.div`
`;

export const SubtotalP = styled.p`
    font-family: Montserrat;
    font-size: 16px';
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const ContainerValorTotal = styled.div`
`;

export const ValorTotalP = styled.p`
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #848484;
`;

export const ContainerFinalizar = styled.div`
    padding: 0px;
    display: block;
    text-align: center;
    margin: 20px;
`;

export const ButtonFinalizar = styled.div`
    display: flex;
    padding: 0px;
    align-items: center;
    justify-content: space-between;
    padding:0px 15px;
    gap: 234px;
    background-color: #50c05f;
    border-radius: 5px;
    cursor: pointer;

    @media (max-width: 425px) {
    gap: 170px;
    }
`;

export const ContainerFinalizarP = styled.div`
    display: flex;
    align-items: center;
`;

export const FinalizarP = styled.p`
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #FFF;
    margin: 0;
`;

export const IconMaior = styled.p`
    display: flex;
    align-items: center;
`;

export const ContinuarCompraP = styled.p`
    font-family: Montserrat;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #848484;
    margin-top: 20px;
    text-decoration-line: underline;
    cursor: pointer;
`;


export const MenuMobileLateral = styled.div`
    width: 28%;
    height: 100%;
    position: fixed;
    top: 0;
    background: #FFF;
    box-shadow: -10px 0 10px -5px rgba(0, 0, 0, 0.07);
    transition: right 0.6s ease;
    transform: translateX(${props => (props.visivel ? '0' : '100%')});
    transform: translateX(${props => (props.visivel ? '0' : '-1%')});
    right: ${props => (props.visivel ? '0' : '-100%')};
    z-index:1;
`;

export const ContainerMenuMobile = styled.div`
    cursor: pointer;
`;

export const ContainerShop = styled.div`
    max-height: ${props => (props.visivel ? '400px' : '0')};
    width: 100%;
    height: 80%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    display: flex;
    overflow: hidden;
    box-shadow: 0px 13px 19px 0px rgba(0, 0, 0, 0.07);
    transition: max-height 0.3s ease;
    left: 0;
    top: 130px;
    z-index:11;

    @media (max-width: 768px) {
        top: 130px;
    }
`;

export const Shop = styled.div`
    width: 100%;
    background: #FAFAFA;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
`;


export const ContainerTitulo = styled.div`
    margin: 40px;
    // width: 140px;
    height: 350px;
    display: flex;
    flex-direction: column;
    // align-items: center;
`;

export const Titulo = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 150% */
    letter-spacing: 0.1px;
    margin-left: 0px;
    display:flex;
    align-items: center;
    
    @media (max-width: 425px) {
        margin:0px;
        margin-top:10px;
        margin-bottom:10px;
    }
`;

export const ContainerSeta = styled.div`
    display: flex;
    align-items: center;
    width: 180px;
    justify-content: space-between;

    @media (max-width: 425px) {
    cursor:pointer;
    width: 100%;
    }

    @media (max-width: 768px) {
    cursor:pointer;
    width: 100%;
    }

    @media (width: 1024px) {
    width: 160px;
    }
`;

export const BoxSeta = styled.div`
    display: none;

    @media (max-width: 425px) {
    display: block;
    }

    @media (max-width: 768px) {
    display: block;
    }
`;

export const Pagina = styled.p`
    color: #737373;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;
    cursor: pointer;
    margin: 8px;
    margin-left: 2px;
`;

//Banner

export const ContainerBanner = styled.div`
`;

export const Banner = styled.div`
    // margin-bottom: 50px;
    padding:20px;
    background-color: #F5F5F5;
`;

//CategoriaProdutos

export const Categoria = styled.div`
`;

export const ContainerCategoria = styled.div`
    // margin: 43px;
    display:flex;
    margin-top:20px;
    flex-direction:column;
    padding: 20px 50px;

    @media (max-width: 425px) {
    margin: 0px;
    padding: 15px;
    }
`;

export const ContainerNavCategoria = styled.div`
    border-bottom: solid 1px #D2D2D2;
    // margin: 15px;
    padding-bottom: 10px;

    @media (min-width: 1440px) {
    margin: 15px;
    }
`;

export const CategoriaFlex = styled.div`
    margin: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ContainerTitulop = styled.div`
    display: flex;
    align-items: center;
`;

export const TituloCategoria = styled.p`
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    margin: 0;

    @media (max-width: 425px) {
    font-size: 16px;
    width:210px;
    }
`;

export const ContainerVerMais = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const VermaisP = styled.p`
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    margin-right: 5px;
    margin: 0;
    white-space: nowrap;
`;

export const CardList = styled.div`
    margin-top: 30px;
    display: flex;
    overflow-x: auto;
    // justify-content: center;
    padding: 2px 2px;
    transform: rotateX(180deg);
    position: relative;

    & > * {
        transform: rotateX(180deg);
    }

     /* Torne a barra de rolagem invisível no Webkit */
    &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    /* Outros estilos para Firefox */
    scrollbar-width: none; /* Firefox */

    & {
        -ms-overflow-style: none;  /* IE and Edge */
    }

    @media (min-width: 1440px) {
       margin-left:15px;
    }
`;

export const CardListSetor3 = styled.div`
    margin-top: 30px;
    display: flex;
    // padding: 2px 2px;
    // justify-content: center;
    // align-items: center;

    @media (max-width: 425px) {
        flex-direction: column;
    }
    @media (min-width: 768px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

     @media (min-width: 1024px) {
        flex-direction: row;
    }
`;

export const CardListSetores = styled.div`
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    // display: flex;
    // padding: 2px;
    // justify-content: center;
    // align-items: center;

    @media (max-width: 425px) {
        display: flex;
        flex-direction: column;
    }

    @media (min-width: 768px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    @media (min-width: 1024px) {
        flex-direction: row;
    }

    // & > * {
    //     flex: 1;
    //     max-width: 100%;
    // }
`;


export const CardProduto = styled.div`
    display: flex;
    width: 246px;
    // padding-left: 1px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-radius: 20px;
    border: 2px solid #F5F5F5;
    background: #FFF;
    margin-right: 15px;

`;

export const CardSetores = styled.div`
    text-align: center;
    margin-right: 21px;
`;

export const TitularDoSetor = styled.div`
    display: flex;
    position:relative;
    // width: 530px;
    height: 360px;
    margin: 15px;
    // padding: 204px 61px 50px 61px;
    justify-content: center;
    // align-items: center;
    align-items: flex-end;
    gap: 228px;
    flex-shrink: 0;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) -25%, rgba(102, 102, 102, 0.1) 83%);
    border-radius: 20px;

    @media (min-width: 2560px) {
        height: 650px;
    }

    @media (max-width: 425px) {
        width: auto; /* Mantém 100% da largura do pai */
        height: 480px;
        margin: 0px;
        margin-bottom: 15px;
        display:flex;
        align-items: flex-end;
        justify-content: flex-start;
        // padding: 30px; 
    }

    @media (max-width: 768px) {
        margin: 5px;
        margin-bottom: 15px;
    }

    @media (width: 1024px) {
        // width: 335px;
        height: 300px;
        margin: 5px;
    }
`;

export const TitularDoSetor3 = styled.div`
    display: flex;
    // width: 530px;
    height: 360px;
    // padding: 10px;
    margin: 15px;
    // padding: 204px 61px 38px 61px;
    justify-content: center;
    align-items: center;
    gap: 228px;
    flex-shrink: 0;
    background: #D2D2D2;
    border-radius: 20px;

     @media (min-width: 2560px) {
       height: 650px;
    }

    @media (max-width: 425px) {
     width: auto;
     height: 480px;
     margin: 5px;
     margin-bottom:15px;
    }

    @media (width: 1024px) {
        // width: 335px;
        height: 300px;
        margin: 5px;
        margin-bottom:10px;
    }
`;

export const ContainerTipoSetor = styled.div`
    display: flex;
    flex-direction:column;
    width: 100%;
    height: auto;
    
`;

export const FlexSetor = styled.div`
    display: flex;
    position:absolute;
    padding:40px;
    width: 80%;
    justify-content: space-between;
    // margin-bottom:50px;

    @media (max-width: 425px) {
    width: 50%;
    display:flex;
    flex-direction:column;
    }

    @media (min-width: 768px) {
    align-items:center;
    }

    @media (max-width: 1024px) {
    display:flex;
    }

    @media (min-width: 2560px) {
    padding: 0px 0px 60px 0px;
    }
`;

export const TituloSetorFlex = styled.div`
`;

export const TituloSetorP = styled.p`
    color: #FFF;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.1px;
    margin: 0;

    // @media (max-width: 768px) {
    // margin-bottom:20px;
    // white-space: nowrap;
    // }

    @media (max-width: 425px) {
    margin-bottom:20px;
    white-space: nowrap;
    }
    
`;

export const ButtonSetor = styled.div`
    display: flex;
    padding: 0 45px;
    flex-direction: column;
    align-items: center;
    background-color:#0d0d0da3;
    border-radius: 5px;
    border: 2px solid #FFF;
    cursor: pointer;

    @media (max-width: 425px) {
        padding: 0 ;
    }

    @media (width: 1024px) {
        padding: 0 30px;
    }
`;

export const SaibaMaisP = styled.p`
    color: #FFF;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.2px;

    @media (max-width: 425px) {
        margin:10px;
        white-space: nowrap;
    }

    @media (max-width: 768px) {
        white-space: nowrap;
    }

    @media (max-width: 1024px) {
        white-space: nowrap;
    }

`;

export const SetorImg = styled.div`
    width: 198px;
    height: 198px;
    flex-shrink: 0;
    border-radius: 20px;
    background: #F5F5F5;
`;

export const TituloSetor = styled.p`
    color: #666;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

export const ContainerProdutoCard = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    width: 100%;
    height: 200px;
    background: #F5F5F5;
    // margin-top: 1px;
    border-radius: 18px 18px 0 0;
`;

export const ContainerSobreProduto = styled.div`
`;

export const MarginP = styled.div`
    margin: 20px;
    padding: 0px 79px 0px 0px;
`;

export const NomeProdutoCard = styled.div`
    font-family: Montserrat;
    font-size: 16px
    font-style: normal;
    font-weight: 500;
    line-height: 30px;
    margin: 0;
    color: #222;
`;

export const ContainerValorCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerValorInicial = styled.div`
    margin-right: 10px;
`;

export const ValorInicialP = styled.p`
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    padding: 0;
    margin: 0;
    color: #222;
    color: #D2D2D2;
    text-decoration: line-through;
`;

export const ContainerValorNovo = styled.div`
`;

export const ValorNovoP = styled.p`
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    padding: 0;
    margin: 0;
    color: #222;
`;

export const NovoProdutoP = styled.p`
    font-family: Montserrat;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    color: #FFF;
    white-space: nowrap;


    @media (max-width: 425px) {
        font-size: 8px;
    }

    @media (max-width: 375px) {
        font-size: 7px;
    }

    @media (max-width: 320px) {
        font-size: 6px;
    }
`;

export const DescontoP = styled.p`
    font-family: Montserrat;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    color: #FFF;
    white-space: nowrap;


    @media (max-width: 425px) {
        font-size: 8px;
    }

    @media (max-width: 375px) {
        font-size: 7px;
    }

    @media (max-width: 320px) {
        font-size: 6px;
    }
`;

export const ProductCardStatus = styled.div`
    display: flex;
    padding: 20px;
    position:absolute;
    top:375px;
`;

export const NovoProduto = styled.div`
    display: flex;
    padding: 2px 7px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 15px;
    background: #D2D2D2;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
    margin-right: 10px;

`;

export const Desconto = styled.div`
    display: flex;
    padding: 2px 7px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 15px;
    background: #D2D2D2;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
`;

//Descricoes

export const Descricoes = styled.div`
    display: flex;
    justify-content: center;

     @media (max-width: 425px) {
        display: block;
    }
`;

export const ContainerD = styled.div`
    display: flex;
    padding: 40px 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0px 30px;

    @media (width: 1024px) { 
    margin:15px;
    }
`;

export const CTituloLinha = styled.div`
    display: flex;
    
    flex-direction: column;
    align-items: center;
`;

export const DSubtitulo = styled.p`
    color: #737373;
    text-align: center;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.2px;
    margin: 10px;
`;

export const DTL = styled.p`
    color: #252B42;
    text-align: center;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.1px;
    margin: 10px;
`;

export const DTLDescricao = styled.p`
    color: #737373;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.2px;
    margin: 10px;
`;

export const CardListD = styled.div`
    display: flex;
    
    margin-top: 50px;
    align-items: center;
    justify-content: center;
    gap: 50px;
    text-align: center;

     @media (max-width: 425px) {
        display: block;
    }
`;

export const CardD2List = styled.div`
    display: flex;
    gap: 55px;

    @media (max-width: 425px) {
        display: block;
    }

    @media (max-width: 768px) {
        display: block;
    }

     @media (width: 1024px) {
       gap: 10px;
    }
`;

export const CardD2 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media (max-width: 425px) {
        margin: 20px;
    }

    @media (max-width: 768px) {
        margin: 20px;
    }
`;

export const CardD = styled.div`
    display: flex;
    padding: 35px 40px;
    flex-direction: column;
    align-items: center;
`;

export const TituloD = styled.p`
    color: #252B42;
    text-align: center;

    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 133.333% */
    letter-spacing: 0.1px;
    margin: 15px;
`;

export const TituloD2 = styled.p`
    display: flex;
    width: 152.09px;
    height: 15.24px;
    flex-direction: column;
    justify-content: center;

    color: #3A3A3A;
    text-align: center;
    font-family: Inter;
    font-size: 14.742px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.24px; /* 103.377% */
    margin: 0;
    margin-top: 15px;
    padding: 0
`;

export const DescricaoD = styled.p`
    color: #737373;
    text-align: center;

    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin: 0;
    padding: 0;
`;

export const DescricaoD2 = styled.p`
    color: #848484;
    text-align: center;
    font-family: Inter;
    font-size: 12.539px;
    font-style: normal;
    font-weight: 300;
    line-height: 18.75px; /* 149.533% */

    @media (max-width: 425px) {
        width: 181.66px;
    }

    @media (max-width: 768px) {
        width: 181.66px;
    }

    @media (min-width: 2560px) {
        width: 200px;
    }

    @media (width: 1024px) {
        font-size: 10.539px;
    }


`;

//Footer

export const Footer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const FooterC = styled.div`
`;

export const FooterHeader = styled.div`  
    display: flex;
    width: 100%;
    padding: 50px 0px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    z-index: 0;
    position: relative;

    @media (max-width: 425px) {
        padding: 0;
    }

     @media (max-width: 768px) {
        padding: 0;
    }
`;

export const HeaderFooterSocial1 = styled.div`  
    display: flex;
    justify-content: space-between;
    max-width: 1050px;

    @media (min-width: 768px) {
        margin:15px;
    }
`;

export const HeaderFooterSocial2 = styled.div`  
    display: flex;
    justify-content: space-between;
    width: 90%;
    max-width: 1050px;
    border-bottom: solid 1px #E6E6E6;
    padding: 50px 0px;

     @media (max-width: 425px) {
        margin: 15px;
    }

    @media (max-width: 768px) {
        margin: 15px;
    }

    @media (max-width: 1024px) {
        margin: 15px;
    }
`;

export const ButtonFooterHeader = styled.button`  
    display: flex;
    padding: 0px 40px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 10px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    background: #D2D2D2;

    @media (max-width: 425px) {
        margin: 15px;
    }
`;

export const ButtonFooterP = styled.p`  
    color: #000;
    text-align: center;

    /* btn-text */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; /* 157.143% */
    letter-spacing: 0.2px;
`;

export const FooterMain = styled.div`
    display: flex;
    width: 100%;
    padding: 50px 0px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    gap: 30px;

    @media (max-width: 425px) {
        display: block;
        // padding: 20px 0px;
        width:100%;
    }

    @media (max-width: 768px) {
        display: block;
        // padding: 20px 0px;
        width:100%;
    }
`;

export const ContainerFooter = styled.div`
    display: flex;
    justifyContent: space-between;
    justify-content: center;

    @media (max-width: 425px) {
        display: flex;
        flex-direction: column;
        margin: 15px;
        justify-content: flex-start;
    }

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        margin: 15px;
        justify-content: flex-start;
    }
`;

export const ContainerFooter1 = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 1050px;

     @media (max-width: 425px) {
        display:block;
        width: auto;
        margin: 15px;
    }

    @media (max-width: 768px) {
        display:block;
        width: auto;
        margin: 15px;
    }

    @media (width: 1024px) {
        width: 950px;
    }
`;

export const CardFooter = styled.div`
    display: flex;
    // width: 148px;
    flex-direction: column;
    align-items: flex-start;

    // @media (max-width: 425px) {
    // }
`;

export const CardFooter5 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const ContainerEmail = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 425px) {
    // width: 148px;
    }
`;

export const InputEmail = styled.div`
    display: flex;
    padding: 1px 23px 0px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 5px 0px 0px 5px;
    border: 1px solid #E6E6E6;
    background: #F9F9F9;

    @media (max-width: 425px) {
        padding: 0px;
        width: 100%;
    }
`;

export const ButtonEnviarEmail = styled.button`
    border-radius: 0px 5px 5px 0px;
    border: 1px solid #E6E6E6;
    cursor: pointer;
    display: inline-flex;
    height: 38.5px;
    padding: 0px 39px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    background: #D2D2D2;

    @media (max-width: 425px) {
        padding: 0px 35px;
    }
`;

export const PEmail = styled.p`
    color: #FFF;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.2px;
`;

export const FooterRodape = styled.div`  
    background: #FAFAFA;
    display: flex;
    padding: 20px;
    justify-content: space-around;
    align-items: center;

`;

export const Copy = styled.div`  
    color: #848484;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.2px;

    @media (max-width: 320px) {
        font-size: 12px;
    }
`;


export const LogoC = styled.div`
    @media (max-width: 425px) {
    margin:15px;
    }
`;

export const FPLogo = styled.p`
    color: #000;

    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.1px;
    margin: 0;

    @media (max-width: 320px) {
        font-size: 18px;
    }
`;

export const SubtituloArea = styled.p`
    @media (max-width: 320px) {
        font-size: 12px;
    }
`;

export const SocialC = styled.div`
    display: flex;
    gap: 15px;
`;

//Responsivo Home

export const MaisOpcoesMobile = styled.div`
    display: none;

    @media (max-width: 950px) {
    display: block;
    cursor: pointer;
    }
`;

export const PesquisaMobile = styled.div`
    display: none;

    @media (max-width: 950px) {
    display: block;
    margin: 8px;
    cursor: pointer;
    }
`;

export const BarraPesquisaMobile = styled.div`
    @media (max-width: 425px) {
    border-radius: 15px;
    border: none;
    background: #F5F5F5;
    display: inline-flex;
    padding: 7px 18px;
    width: 100%;
    align-items: flex-start;
    gap: 5px;
    margin:10px;
    margin-bottom:20px;
    }

`;

// export const ContainerBarraPesquisaMobile = styled.div`
//     display: none;

//     @media (max-width: 425px) {
//     max-height: ${props => (props.visivel ? '150%' : '0')};
//     width: 100%;
//     background-color: #FFF;
//     display: flex;
//     overflow: hidden;
//     transition: max-height 0.6s ease;
//     left: 0;
//     top: 160px;
//     z-index:1;
//     }

// `;

export const ContainerBarraPesquisaMobile = styled.div`
    display: none;

    @media (max-width: 950px) {
        height: ${props => (props.visivel ? '62px' : '0')}; /* Ajuste a altura conforme necessário */
        width: 100%;
        background-color: #FFF;
        display: flex;
        overflow: hidden;
        transition: height 0.6s ease;
        left: 0;
        top: 160px;
        z-index: 1;
    }
`;

//Footer acordeon mobile
export const Paginas = styled.div`
  @media (max-width: 950px) {
    max-height: ${props => (props.isOpen ? '500px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease-out;
  }s

  @media (max-width: 768px) {
    max-height: ${props => (props.isOpen ? '500px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease-out;
  }
`;

//Opcoes mobile

export const OpcoesMobile = styled.div`
    display: none;

    @media (max-width: 950px) {
    max-height: ${props => (props.visivel ? '150%' : '0')};
    width: 100%;
    background-color: #FFF;
    // padding-top:0px;
    position: absolute;
    display: flex;
    overflow: hidden;
    box-shadow: 0px 13px 19px 0px rgba(0, 0, 0, 0.07);
    transition: max-height 0.6s ease;
    left: 0;
    top: 120px;
    z-index:11;
    }

    // @media (max-width: 375px) {
    // top: 139px;
    // }

    // @media (max-width: 320px) {
    // top: 156px;
    // }

`;

export const CadastroBox = styled.div`
    @media (max-width: 950px) {
        align-items: center;
        display: inline-flex;
        padding: 15px 20px;
        align-items: center;
        gap: 10px;
        border-radius: 15px;
        background: #D2D2D2;
    }

    
`;

export const ContainerOpcoes = styled.div`
    @media (max-width: 950px) {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    
`;

export const UsuarioMobile = styled.div`
  @media (max-width: 950px) {
        display: flex;
        padding: 5px;
        align-items: flex-start;
        gap: 10px;
        border-radius: 10px;
        background: #FFF;
    }
`;


export const ButtonContaMobile = styled.div`
  @media (max-width: 950px) {
        display: flex;
        width: 105px;
        padding: 6px 0px;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        background: #FFF;
    }
`;

export const Contap = styled.p`
  @media (max-width: 950px) {
        color: #000;
        font-family: Montserrat;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.2px;
        margin:0;
    }
`;

export const ContainerTituloMobile = styled.div`
  @media (max-width: 950px) {
        margin: 5px;
        margin-bottom: 10px;
        // width: 100%;
        align-items: center;
    }
`;